import script from "./Bracket.vue?vue&type=script&lang=ts&setup=true"
export * from "./Bracket.vue?vue&type=script&lang=ts&setup=true"

import "./Bracket.vue?vue&type=style&index=0&id=5c0879e1&lang=css"

const __exports__ = script;

export default __exports__